export default __webpack_public_path__ + "static/media/flag-switzerland.c703eca4.svg";